import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import { List, Popconfirm, Spin, Tag, Avatar, Tooltip } from "antd";
import { RightOutlined } from "@ant-design/icons";
import { reactNl2Br } from "@devowl-wp/react-utils";
import { useI18n, useListContentBlocker, useUpsell } from "../../../contexts";
import { ListMultilingualLanguages } from "../../common";
const MAX_RULES_ENTRIES = 5;
const ListContentBlockerRow = (param)=>{
    let { busy, attributes: { id, name, description, status, criteria, services, tcfVendors, rules, isVisual, presetId }, avatarUrl, isUpdateAvailable, languages, languageOnClick } = param;
    const { __ } = useI18n();
    const { isLicensed } = useUpsell();
    const { onEdit, onDelete } = useListContentBlocker();
    const [expandAllHosts, setExpandAllHosts] = useState(false);
    // https://stackoverflow.com/a/5002618/5506547
    const useDescription = useMemo(()=>{
        if (description) {
            const element = document.createElement("div");
            element.innerHTML = description;
            return element.textContent;
        }
        return "";
    }, [
        description
    ]);
    return /*#__PURE__*/ _jsx(List.Item, {
        itemID: id.toString(),
        actions: [
            /*#__PURE__*/ _jsx("a", {
                onClick: ()=>onEdit(id),
                children: isUpdateAvailable ? __("Edit and update") : __("Edit")
            }, "edit"),
            /*#__PURE__*/ _jsx(Popconfirm, {
                title: __("Are you sure that you want to delete this content blocker?"),
                placement: "bottomRight",
                onConfirm: ()=>onDelete(id),
                okText: __("Delete"),
                cancelText: __("Cancel"),
                overlayStyle: {
                    maxWidth: 350
                },
                children: /*#__PURE__*/ _jsx("a", {
                    children: __("Delete")
                })
            }, "delete"),
            (languages == null ? void 0 : languages.length) && /*#__PURE__*/ _jsx(ListMultilingualLanguages, {
                recordId: id,
                languages: languages,
                onClick: languageOnClick
            }, "languages")
        ].filter(Boolean),
        children: /*#__PURE__*/ _jsx(Spin, {
            spinning: busy,
            children: /*#__PURE__*/ _jsx(List.Item.Meta, {
                avatar: avatarUrl ? /*#__PURE__*/ _jsx(Avatar, {
                    size: "large",
                    src: avatarUrl,
                    shape: "square"
                }) : /*#__PURE__*/ _jsx(Avatar, {
                    size: "large",
                    shape: "circle",
                    children: name.toUpperCase()[0]
                }),
                title: /*#__PURE__*/ _jsxs("span", {
                    children: [
                        name,
                        " ",
                        status === "draft" ? /*#__PURE__*/ _jsx(Tag, {
                            color: "orange",
                            children: __("Draft")
                        }) : status === "private" ? /*#__PURE__*/ _jsx(Tag, {
                            color: "red",
                            children: __("Disabled")
                        }) : null,
                        criteria === "services" && services.length === 0 && /*#__PURE__*/ _jsxs(Tag, {
                            color: "red",
                            children: [
                                __("No connected services defined"),
                                " ",
                                /*#__PURE__*/ _jsx(RightOutlined, {}),
                                " ",
                                __("Disabled")
                            ]
                        }),
                        criteria === "tcfVendors" && tcfVendors.length === 0 && /*#__PURE__*/ _jsxs(Tag, {
                            color: "red",
                            children: [
                                __("No connected TCF Vendors defined"),
                                " ",
                                /*#__PURE__*/ _jsx(RightOutlined, {}),
                                " ",
                                __("Disabled")
                            ]
                        }),
                        !!presetId && /*#__PURE__*/ _jsx(Tag, {
                            children: __("Created from template")
                        }),
                        !!presetId && !avatarUrl && /*#__PURE__*/ _jsx(Tooltip, {
                            title: isLicensed ? __("There is no longer a content blocker template for this service. Probably the service has been discontinued. Please look for alternatives!") : __("This content blocker was created from a template. As you do not have a license activated at the moment, updates that are potentially available cannot be downloaded."),
                            children: /*#__PURE__*/ _jsx(Tag, {
                                color: "red",
                                children: isLicensed ? __("No longer supported") : __("Possibly outdated")
                            })
                        }),
                        !!isUpdateAvailable && /*#__PURE__*/ _jsx(Tooltip, {
                            title: __("The blocker template has been updated to provide current legal and technical information."),
                            children: /*#__PURE__*/ _jsx(Tag, {
                                color: "green",
                                children: __("Update available")
                            })
                        })
                    ]
                }),
                description: /*#__PURE__*/ _jsxs("div", {
                    children: [
                        !!useDescription && /*#__PURE__*/ _jsx("div", {
                            children: reactNl2Br(useDescription)
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            style: {
                                paddingTop: 5
                            },
                            children: [
                                __("URLs / Elements to block"),
                                ":",
                                " ",
                                rules.slice(0, expandAllHosts ? rules.length : MAX_RULES_ENTRIES).map((host, i)=>/*#__PURE__*/ _jsx(Tag, {
                                        children: host
                                    }, `${host}-${i}`)),
                                rules.length > MAX_RULES_ENTRIES && !expandAllHosts && /*#__PURE__*/ _jsx(Tag, {
                                    onClick: ()=>setExpandAllHosts(true),
                                    children: __("Show all")
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            style: {
                                paddingTop: 5
                            },
                            children: [
                                __("Visual Content Blocker"),
                                ":",
                                " ",
                                /*#__PURE__*/ _jsx(Tag, {
                                    children: isVisual ? __("Yes, if possible") : __("No")
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
export { ListContentBlockerRow };
